import { render } from "./NewCard.vue?vue&type=template&id=1ba64cd4&ts=true"
import script from "./NewCard.vue?vue&type=script&lang=ts"
export * from "./NewCard.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\CTL-Project\\Mbf5_HCC\\XaQuangHa\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__